import React from 'react';

import {asCoreObject} from 'app-core/framework/CoreObjectIntrospectionUtils';
import {handleToggleStar} from 'app-core/platform/starrable/CoreObjectStarIcon';

import {AnalysisSearchAttributesGraphQL} from '../../../../graphql-fragments/analysis-tool/__generated/AnalysisSearchAttributesGraphQL';
import BaseAnalyticsSidepanelItem, {BaseAnalyticsSidepanelItemProps} from './BaseAnalyticsSidepanelItem';

export type AnalysisSidepanelItemProps = {
  analysis: AnalysisSearchAttributesGraphQL;
  isStarred: boolean;
} & Pick<
  BaseAnalyticsSidepanelItemProps<AnalysisSearchAttributesGraphQL>,
  'active' | 'isCompact' | 'openResult' | 'isChild'
>;

export default function AnalysisSidepanelItem(props: AnalysisSidepanelItemProps): JSX.Element {
  function handleClickStar(): void {
    handleToggleStar({
      item: asCoreObject(props.analysis),
      isStarred: props.isStarred,
    });
  }

  return (
    <BaseAnalyticsSidepanelItem
      {...props}
      item={props.analysis}
      handleClickStar={handleClickStar}
      starred={props.isStarred}
      // TODO(BNCH-48696): Track open event for Analyses
    />
  );
}
